export default "__VITE_ASSET__HFC9JLYX__"